import { FormControl, MenuItem, OutlinedInput, Select, ThemeProvider } from '@mui/material';
import PropTypes from 'prop-types';
import React, {useState } from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import { candidatureStatus } from '../../data/Interfaces';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useCraRdv from '../../hooks/useCraRdv';
import useRole from '../../hooks/useRole';
import { FieldComponentFont } from '../../Styles/componentStyles';
import { searchLabelInEnumByValue } from '../../Utils/utils';
import DialogInterviewerCandidature from '../Dialogs/DialogInterviewerCandidature';
import DialogRejeteCandidature from '../Dialogs/DialogRejeteCandidature';

const ChangeStatusCandidature = ({ defaultStatusCandidat,setStatusCandidature, aoId, expertId, width, dossierId}) => {
    ChangeStatusCandidature.propTypes = {
        defaultStatusCandidat: PropTypes.any,
        setStatusCandidature:PropTypes.func,
        aoId: PropTypes.any,
        expertId: PropTypes.any,
        width: PropTypes.any,
        // * dossier context
        dossierId: PropTypes.any,
    };
    const { setSelectedRDV, setOpenNestedInterviewerCandidature, openNestedInterviewerCandidature } = useCraRdv();
    const axiosPrivate = useAxiosPrivate();
    const role = useRole();
    const { i18n } = useTranslation();
    const [openNestedRejetCandidature, setOpenNestedRejetCandidature] = useState(false);
    //useEffect(() => {
    //    console.log(defaultStatusCandidat);
    //    if (defaultStatusCandidat == 'rejected') {
    //        setOpenNestedRejetCandidature(true);
    //    }
    //    if (defaultStatusCandidat == 'interview')
    //        setOpenNestedInterviewerCandidature(true);
    //}, [defaultStatusCandidat]);

    const handleChangeStatus = (e) => {
        const newStatus = e.target.value;
        if(setStatusCandidature instanceof Function)
            setStatusCandidature(newStatus);
        if (newStatus == 'rejected') {
            setOpenNestedRejetCandidature(true);
        }
        if (newStatus == 'interview')
            setOpenNestedInterviewerCandidature(true);
        if (newStatus !== 'rejected' && newStatus !== 'interview')
            updateCandidatureStatus(newStatus);
        if (newStatus == 'interview') {
            //? to share also this info with dialog :)
            setSelectedRDV({
                statusCandidature: 'interview',
                expertId,
                // * AO context
                aoId,
                // * dossier context
                dossierId,
            });
        }
    };

    const updateCandidatureStatus = async (currentStatus) => {
        try {
            const response1 = await axiosPrivate.post('/candidature/updateCandidatureStatus',
                {
                    expertId,
                    'statusCandidature': currentStatus,
                    // * AO context
                    aoId,
                    // * dossier context
                    dossierId,
                }
            );
            const responseData1 = await response1.data;
            console.log('submitresumeBackend', responseData1, responseData1?.message);
            //! we can't see the alert componenet above Dialog
            // ? try smtg else
            Swal.fire('Done!', responseData1?.message, 'success');
        } catch (error) {
            console.log(error.response?.status);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: error.response.data?.error,
                // footer: '<a href="">Why do I have this issue?</a>'
            });
        }
    };

    return (
        <ThemeProvider theme={FieldComponentFont}>
            <FormControl
                //sx={{ m: 1, width: 200, }}
                variant="outlined"
                style={{ width: width }}
            >
                {/* <InputLabel id="demo-multiple-name-label">status de candidature</InputLabel> */}
                <Select
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    input={<OutlinedInput />}
                    sx={{
                        '& > :not(style)': { borderRadius: '8px' },
                    }}
                    //MenuProps={MenuProps}
                    disabled={((role == 'admin' && aoId) || role == 'expert' || defaultStatusCandidat == 'converted')}
                    //defaultValue={defaultStatusCandidat}
                    value={defaultStatusCandidat}
                    onChange={(e) => handleChangeStatus(e)}
                    style={{ backgroundColor: 'white', width: width }}
                >
                    {
                        defaultStatusCandidat === 'converted' ? (
                            <MenuItem
                                style={{ width: width }}
                                value={defaultStatusCandidat}
                            >
                                {/* converted */}
                                {i18n.t(searchLabelInEnumByValue(candidatureStatus, defaultStatusCandidat))}
                                {/* {candidatureStatus[candidatureStatus.length -1].label}  */}
                            </MenuItem>
                        ) : (
                            candidatureStatus.map((option, i) => {
                                if (
                                    dossierId &&
                                    option.value !== 'unread' &&
                                    option.value !== 'analyzed' &&
                                    option.value !== 'converted' //just a double check
                                )
                                    return (
                                        <MenuItem
                                            style={{ width: width }}
                                            key={i}
                                            value={option.value}
                                        >
                                            {i18n.t(option?.label)}
                                        </MenuItem>
                                    );
                                else if (aoId && option.value !== 'converted' && option.value !== 'checkDispo')
                                    return (
                                        <MenuItem
                                            style={{ width: width }}
                                            key={i}
                                            value={option.value}
                                        >
                                            {i18n.t(option?.label)}
                                        </MenuItem>
                                    );
                            })
                        )
                    }
                </Select>
                <DialogRejeteCandidature
                    expertId={expertId}
                    statusCandidature={defaultStatusCandidat}
                    openNestedRejetCandidature={openNestedRejetCandidature}
                    handleCloseNestedRejetCandidature={
                        () => {
                            setOpenNestedRejetCandidature(false);
                        }
                    }
                    aoId={aoId}
                    dossierId={dossierId}
                />
                {/* //L'ESN joue à la fois le rôle d'expert et de client,
                // donc j'ai ajouté le paramètre `roleEsn` pour différencier entre ces deux types. */}
                {openNestedInterviewerCandidature && <DialogInterviewerCandidature roleEsn={role=='esn'? 'EsnClient' : {}}/>}
            </FormControl>
        </ThemeProvider>
    );
};

export default ChangeStatusCandidature;